import { useIntl } from 'react-intl';
import { Form, Row, Col, FormInstance, Card, Divider, Typography } from 'antd';

import FloatingFormItem from '@/components/_common/FloatingFormItem';
import { InputDecimal, InputNumber } from '@/components/_common';
import { useDisclosure } from '@/hooks';
import SituationFormField from '@/components/Movements/DirectSale/SituationFormField';
import { useReleasePurchaseFormContext } from '@/pages/MovementsPage/PurchasesPage/ReleasesPage/ReleasesPurchaseProvider';
import PurchaseSendEmailModal from '../../PurchasesButtonsRepeated/PurchaseSendEmailModal';
import { PurchaseItemTaxes } from '@/core/domain/purchase/Purchase.types';
import PurcheseAlertBoshMigration from '../../PurchaseAlertBoshMigration';

interface Props {
  form: FormInstance<PurchaseItemTaxes>;
  purchaseId?: number;
}

function PurchaseTaxesForm({ form }: Props) {
  const intl = useIntl();
  const [modalEmailVisible, modalEmailAction] = useDisclosure();
  const { situation, purchase } = useReleasePurchaseFormContext();

  return (
    <>
      <Form layout="vertical" form={form} name="purchaseTaxesForm">
        <Row gutter={[16, 9]}>
          <Col span={24}>
            <SituationFormField initialValue={situation} />
          </Col>

          {purchase?.boschMigration && (
            <Col span={24}>
              <PurcheseAlertBoshMigration />
            </Col>
          )}

          <Col xs={24} sm={12} md={6}>
            <FloatingFormItem
              label={intl.formatMessage({
                id: 'purchase.details.taxes.form.icmsValue',
              })}
              name="valueIcms"
              initialValue={0}
            >
              <InputNumber precision={2} disabled />
            </FloatingFormItem>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <FloatingFormItem
              label={intl.formatMessage({
                id: 'purchase.details.taxes.form.icmsStValue',
              })}
              name="valueIcmsSt"
              initialValue={0}
            >
              <InputNumber precision={2} disabled />
            </FloatingFormItem>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <FloatingFormItem
              label={intl.formatMessage({
                id: 'purchase.details.taxes.form.pisValue',
              })}
              name="valuePis"
              initialValue={0}
            >
              <InputNumber precision={2} disabled />
            </FloatingFormItem>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <FloatingFormItem
              label={intl.formatMessage({
                id: 'purchase.details.taxes.form.pisStValue',
              })}
              name="valuePisSt"
              initialValue={0}
            >
              <InputNumber precision={2} disabled />
            </FloatingFormItem>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <FloatingFormItem
              label={intl.formatMessage({
                id: 'purchase.details.taxes.form.ipiValue',
              })}
              name="valueIpi"
              initialValue={0}
            >
              <InputNumber precision={2} disabled />
            </FloatingFormItem>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <FloatingFormItem
              label={intl.formatMessage({
                id: 'purchase.details.taxes.form.cofinsValue',
              })}
              name="valueCofins"
              initialValue={0}
            >
              <InputNumber precision={2} disabled />
            </FloatingFormItem>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <FloatingFormItem
              label={intl.formatMessage({
                id: 'purchase.details.taxes.form.cofinsStValue',
              })}
              name="valueCofinsSt"
              initialValue={0}
            >
              <InputNumber precision={2} disabled />
            </FloatingFormItem>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <FloatingFormItem
              label={intl.formatMessage({
                id: 'purchase.details.taxes.form.issqnValue',
              })}
              name="valueIssqn"
              initialValue={0}
            >
              <InputNumber precision={2} disabled />
            </FloatingFormItem>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <FloatingFormItem
              label={intl.formatMessage({
                id: 'purchase.details.taxes.form.fcpValue',
              })}
              name="valueNormalFcp"
              initialValue={0}
            >
              <InputNumber precision={2} disabled />
            </FloatingFormItem>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <FloatingFormItem
              label={intl.formatMessage({
                id: 'purchase.details.taxes.form.fcpStValue',
              })}
              name="valueFcpStNfc"
              initialValue={0}
            >
              <InputNumber precision={2} disabled />
            </FloatingFormItem>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <FloatingFormItem
              label={intl.formatMessage({
                id: 'purchase.details.taxes.form.bcValue',
              })}
              name="bcValue"
              initialValue={0}
            >
              <InputNumber precision={2} disabled />
            </FloatingFormItem>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <FloatingFormItem
              label={intl.formatMessage({
                id: 'purchase.details.taxes.form.expensesValue',
              })}
              name="expensesValue"
              initialValue={0}
            >
              <InputNumber precision={2} disabled />
            </FloatingFormItem>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <FloatingFormItem
              label={intl.formatMessage({
                id: 'purchase.details.taxes.form.taxAmountValue',
              })}
              name="taxAmountValue"
              initialValue={0}
            >
              <InputNumber precision={2} disabled />
            </FloatingFormItem>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <FloatingFormItem
              label={intl.formatMessage({
                id: 'purchase.details.taxes.form.transactionsFinancialValue',
              })}
              name="transactionsFinancialValue"
              initialValue={0}
            >
              <InputNumber precision={2} disabled />
            </FloatingFormItem>
          </Col>
        </Row>

        <Divider />

        <Typography.Title level={3}>Totais de tributos</Typography.Title>

        <Card style={{ marginBottom: 24 }} title="Totais IS/IBS/CBS">
          <Row gutter={[16, 16]}>
            {/* <Col span={14} md={7} lg={6} xl={6}>
              <FloatingFormItem
                name="governmentReducer"
                label="Redução de Alíquota (%)"
                extra="Relação a compra governamental"
              >
                <InputDecimal disabled />
              </FloatingFormItem>
            </Col>

            <Col span={14} md={7} lg={6} xl={6}>
              <FloatingFormItem name="selectiveTaxTotal" label="Total IS">
                <InputDecimal disabled />
              </FloatingFormItem>
            </Col> */}

            <Col span={14} md={7} lg={6} xl={6}>
              <FloatingFormItem
                name="ibsCbsBcTotal"
                label="Base de Calculo Total IBS/CBS"
              >
                <InputDecimal disabled />
              </FloatingFormItem>
            </Col>
          </Row>
        </Card>

        <Card style={{ marginBottom: 24 }} title="Totais IBS">
          <Row gutter={[16, 16]}>
            {/* <Col span={14} md={7} lg={6} xl={6}>
              <FloatingFormItem
                name="ibsUfDeferralTotal"
                label="UF Diferimento Total IBS"
              >
                <InputDecimal disabled />
              </FloatingFormItem>
            </Col>

            <Col span={14} md={7} lg={6} xl={6}>
              <FloatingFormItem
                name="ibsUfReturnedTaxTotal"
                label="UF Redução Total IBS"
              >
                <InputDecimal disabled />
              </FloatingFormItem>
            </Col> */}

            <Col span={14} md={7} lg={6} xl={6}>
              <FloatingFormItem name="ibsUfTotal" label="UF Total IBS">
                <InputDecimal disabled />
              </FloatingFormItem>
            </Col>

            {/* <Col span={14} md={7} lg={6} xl={6}>
              <FloatingFormItem
                name="ibsMunicipalDeferralTotal"
                label="Muni. Diferimento Total IBS"
              >
                <InputDecimal disabled />
              </FloatingFormItem>
            </Col>

            <Col span={14} md={7} lg={6} xl={6}>
              <FloatingFormItem
                name="ibsMunicipalReturnedTaxTotal"
                label="Min. Redução Total IBS"
              >
                <InputDecimal disabled />
              </FloatingFormItem>
            </Col> */}

            <Col span={14} md={7} lg={6} xl={6}>
              <FloatingFormItem
                name="ibsMunicipalTotal"
                label="Muni. Total IBS"
              >
                <InputDecimal disabled />
              </FloatingFormItem>
            </Col>

            <Col span={14} md={7} lg={6} xl={6}>
              <FloatingFormItem name="ibsTotal" label="IBS Total">
                <InputDecimal disabled />
              </FloatingFormItem>
            </Col>

            {/* <Col span={14} md={7} lg={6} xl={6}>
              <FloatingFormItem
                name="ibsPresumedCreditTotal"
                label="Crédito Presumido Total IBS"
              >
                <InputDecimal disabled />
              </FloatingFormItem>
            </Col>

            <Col span={14} md={7} lg={6} xl={6}>
              <FloatingFormItem
                name="ibsPresumedCreditSuspendedConditionTotal"
                label="Valor Total CP em Condição Suspensiva IBS"
              >
                <InputDecimal disabled />
              </FloatingFormItem>
            </Col>

            <Col span={14} md={7} lg={6} xl={6}>
              <FloatingFormItem
                name="monophasicIbsTotal"
                label="Total Monofásico IBS"
              >
                <InputDecimal disabled />
              </FloatingFormItem>
            </Col>

            <Col span={14} md={7} lg={6} xl={6}>
              <FloatingFormItem
                name="monophasicIbsRetentionTotal"
                label="Total Retenção Monofásico IBS"
              >
                <InputDecimal disabled />
              </FloatingFormItem>
            </Col>

            <Col span={14} md={7} lg={6} xl={6}>
              <FloatingFormItem
                name="monophasicIbsRetainedTotal"
                label="Total Monofásico Retido IBS"
              >
                <InputDecimal disabled />
              </FloatingFormItem>
            </Col>

            <Col span={14} md={7} lg={6} xl={6}>
              <FloatingFormItem
                name="monophasicCbsRetainedTotal"
                label="Total Monofásico Retido IBS"
              >
                <InputDecimal disabled />
              </FloatingFormItem>
            </Col>

            <Col span={14} md={7} lg={6} xl={6}>
              <FloatingFormItem
                name="ibsReversedTotal"
                label="Total Revertido IBS"
              >
                <InputDecimal disabled />
              </FloatingFormItem>
            </Col> */}
          </Row>
        </Card>

        <Card style={{ marginBottom: 24 }} title="Totais CBS">
          <Row gutter={[16, 16]}>
            {/* <Col span={14} md={7} lg={6} xl={6}>
              <FloatingFormItem
                name="cbsDeferralTotal"
                label="Diferimento Total CBS"
              >
                <InputDecimal disabled />
              </FloatingFormItem>
            </Col>

            <Col span={14} md={7} lg={6} xl={6}>
              <FloatingFormItem
                name="cbsReturnedTaxTotal"
                label="Redução Total CBS"
              >
                <InputDecimal disabled />
              </FloatingFormItem>
            </Col> */}

            <Col span={14} md={7} lg={6} xl={6}>
              <FloatingFormItem name="cbsTotal" label="Total CBS">
                <InputDecimal disabled />
              </FloatingFormItem>
            </Col>

            {/* <Col span={14} md={7} lg={6} xl={6}>
              <FloatingFormItem
                name="cbsPresumedCreditTotal"
                label="Total Crédito Presumido CBS"
              >
                <InputDecimal disabled />
              </FloatingFormItem>
            </Col>

            <Col span={14} md={7} lg={6} xl={6}>
              <FloatingFormItem
                name="cbsPresumedCreditSuspendedConditionTotal"
                label="Valor Total CP em Condição Suspensiva CBS"
              >
                <InputDecimal disabled />
              </FloatingFormItem>
            </Col>

            <Col span={14} md={7} lg={6} xl={6}>
              <FloatingFormItem
                name="monophasicCbsTotal"
                label="Total Monofásico CBS"
              >
                <InputDecimal disabled />
              </FloatingFormItem>
            </Col>

            <Col span={14} md={7} lg={6} xl={6}>
              <FloatingFormItem
                name="monophasicCbsRetentionTotal"
                label="Total Retenção Monofásico CBS"
              >
                <InputDecimal disabled />
              </FloatingFormItem>
            </Col>

            <Col span={14} md={7} lg={6} xl={6}>
              <FloatingFormItem
                name="cbsReversedTotal"
                label="Total Revertido CBS"
              >
                <InputDecimal disabled />
              </FloatingFormItem>
            </Col> */}
          </Row>
        </Card>
      </Form>

      <PurchaseSendEmailModal
        open={modalEmailVisible}
        onCancel={modalEmailAction.close}
      />
    </>
  );
}

export default PurchaseTaxesForm;
